






import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME as ConstName } from '../constants';
import { apiProvider } from '../api';

type DataType = {
	MioId: number;
	Text: string;
	ND_NR : string;
	MNOZSTVI_OBJ : number;

};

export default BaseSelect.extend({
	name: selectName(ConstName),
	props: {
		labelKey: { type: String, default: 'MioId' },
		isClearable: { type: Boolean, default: true },
	},
	data() {
		return {
			storeObject: ConstName,
			valueFieldName: 'MioId',
			apiProvider,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				osobniCis: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: DataType) {
			return {
				value: data.MioId,
				text: data.Text,
				ND_NR: data.ND_NR,
				MNOZSTVI_OBJ: data.MNOZSTVI_OBJ,
			};
		},

		async selected({ row }: any) {
			const data = this.dbToBaseMapper(row);
			const { mode } = this;
			if (this.mutationName) {
				this.$store.commit(this.mutationName, { data, mode });
			} else {
				this.dataMapper && this.dataMapper({ data });
			}
			this.actionName && await this.$store.dispatch(this.actionName, { data }, { root: true });
		},
	},
});
